export default {
  range: 'range',
  single: 'single',
};
